import { service } from '@/api/services'
import store from '@/store'

let res = null

export const services = {
    namespaced: true,
    state: {

    },
    mutations: {
       
    },
    actions: {
       // @Description 기관 서비스계약 신청
       async REG_SERVICE({commit}, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await service.post.contract(payload)
                console.log('REG_SERVICE info', res)
                if(res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'success', inset: false})
                } else {
                    store.commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error', inset: false})
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch(error) {
                store.commit('CLOSE_LOADING')
                console.error('REG_SERVICE error', error)

            }
       }
    },
    getters: {
       
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/services.js